import { SearchModelItems } from '@app/entities/models/search/search-model-items.model';

export class SearchModel {
  showViewAll!: boolean;
  items!: SearchModelItems[];
}
